import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './CreateTrigger.css';

const ThreadsView = () => {
  const [applications, setApplications] = useState([]);
  const [selectedAuth, setSelectedAuth] = useState(null);
  const [threads, setThreads] = useState([]);
  const [messageCounts, setMessageCounts] = useState({});
  const [newAppId, setNewAppId] = useState('');
  const [newMessage, setNewMessage] = useState('');

  useEffect(() => {
    axios.get('/api/application/trigger')
      .then(res => setApplications(res.data || []))
      .catch(err => console.error('Failed to load applications:', err));

    axios.get('/api/assistants_chat')
      .then(res => {
        const counts = {};
        res.data.forEach(chat => {
          const appId = parseInt(chat.application);
          if (!counts[appId]) counts[appId] = 0;
          counts[appId]++;
        });
        setMessageCounts(counts);
      })
      .catch(err => console.error('Failed to load messages:', err));
  }, []);

  const handleSelect = async (auth) => {
    setSelectedAuth(auth);
    try {
      const res = await axios.get('/api/assistants_chat');
      const filtered = res.data.filter(chat => {
        const app = applications.find(a => a.id === parseInt(chat.application));
        return app?.authentication === auth;
      });
      setThreads(filtered);
    } catch (err) {
      console.error('Failed to fetch chat threads:', err);
    }
  };

  const handleTriggerSubmit = async () => {
    if (!newAppId || !newMessage.trim()) return alert('Please select an application and enter a message.');

    const app = applications.find(a => a.id === parseInt(newAppId));
    if (!app) return alert('Invalid application.');

    const payload = {
      applicationId: app.id,
      applicationName: app.name,
      emailBody: newMessage
    };

    try {
      await axios.post('/api/tool', payload);
      setNewAppId('');
      setNewMessage('');
      alert('Trigger created successfully.');
    } catch (err) {
      console.error('Error creating trigger:', err);
      alert('Failed to create trigger.');
    }
  };

  return (
    <div className="threads-container">
      <h2>Assistant Threads</h2>

      <div className="thread-grid">
        {applications.map((app, idx) => (
          <div
            key={idx}
            className={`thread-card ${selectedAuth === app.authentication ? 'selected' : ''}`}
            onClick={() => handleSelect(app.authentication)}
          >
            <h4>{app.name}</h4>
            <p className="auth-tag">Auth: {app.authentication}</p>
            <p className="count-tag">Messages: {messageCounts[app.id] || 0}</p>
          </div>
        ))}
      </div>

      <div className="trigger-form" style={{ marginTop: '30px', padding: '20px', background: '#f8f8f8', borderRadius: '8px' }}>
        <h3>Create New Trigger</h3>
        <select className="textinput" value={newAppId} onChange={(e) => setNewAppId(e.target.value)}>
          <option value="">Select Application</option>
          {applications.map(app => (
            <option key={app.id} value={app.id}>{app.name}</option>
          ))}
        </select>

        <textarea
          className="textarea"
          placeholder="Enter message content"
          value={newMessage}
          onChange={(e) => setNewMessage(e.target.value)}
          rows="4"
        />

        <button className="button" onClick={handleTriggerSubmit}>Send Message</button>
      </div>


    </div>
  );
};

export default ThreadsView;
